'use client';

import { Icon } from '@/components/Icon';

/**
 * `.link-phone` / `.link-calendar` on the legacy site: bold 16px/1.5, an icon
 * 8px before the label, primary link colour, underline on hover.
 */
export const HERO_CARD_LINK_CLASS =
  'hover:text-primary-dark focus-visible:ring-primary text-primary inline-flex items-center gap-2 rounded-sm text-base/[1.5] font-bold hover:underline focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none';

/**
 * The icon-led call link the hero cards share — the tabbed cards' post-CTA
 * block and the Prices card's call CTA. One component so the two cannot drift
 * apart visually, and so `tel:` normalisation happens in a single place.
 *
 * Renders nothing when the number carries no digits: an editor's unfilled
 * placeholder would otherwise become `tel:` with an empty target.
 */
export function HeroCardPhoneLink({
  phone,
  label,
}: {
  phone: string | undefined;
  label: string | undefined;
}) {
  const dialable = (phone ?? '').replace(/[^+\d]/g, '');
  if (!dialable) {
    return null;
  }
  const display = label || phone;
  return (
    <p className="m-0 text-center">
      <a
        href={`tel:${dialable}`}
        className={HERO_CARD_LINK_CLASS}
        aria-label={`Anrufen: ${display}`}
      >
        <Icon src="/icons/phone.svg" size={16} className="shrink-0" />
        {display}
      </a>
    </p>
  );
}
